module.exports = __webpack_public_path__ + "img/Shangwh.42357345.svg";